/* ══════════════════════════════════════════════════
   assets/mega-menu.js — Mega Menú JSON (MM51)
   Vanilla JS — sin dependencias externas.
   Requiere: window.MM51_DATA (inyectado desde metafield shop)
══════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Estado ──────────────────────────────────── */
  var menuData   = null;
  var activePanel = null;
  var closeTimer  = null;
  var globalEventsAttached = false;
  var openRafId   = null;

  /* ── Helper de extracción de texto robusto ───── */
  function _getText(obj) {
    if (!obj) return '';
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number') return String(obj);
    
    var text = obj.label || obj.title || obj.name || obj.text || obj.heading || obj.tab_title || obj.category_name;
    
    if (typeof text === 'object' && text !== null) {
      return text.value || text.es || text.en || '';
    }
    
    return text || '';
  }

  /* ── Helper para obtener configuración de destacado desde el Header ───── */
  function getHeaderHighlightConfig() {
    var headerEl = document.querySelector('header.theme__header[data-featured-link]');
    if (!headerEl) return null;

    var link = headerEl.getAttribute('data-featured-link') || '';
    var color = headerEl.getAttribute('data-featured-color') || '';

    if (!link.trim()) return null;

    return {
      item: link.trim().toLowerCase(),
      color: color.trim()
    };
  }

  /* ── Selectores ──────────────────────────────── */
  function getNavbar()  { return document.getElementById('mm51-navbar'); }
  function getPanels()  { return document.getElementById('mm51-panels'); }
  function getOverlay() { return document.getElementById('mm51-overlay'); }

  /* ── Posición del panel ──────────────────────── */
  function setMmTop() {
    var navbar = getNavbar();
    if (!navbar) return;
    var bottom = navbar.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--mm51-top', bottom + 'px');
  }

  /* ── Búsqueda inteligente de MegaMenú ── */
  function findMegamenu(id) {
    if (!menuData || !menuData.megamenus) return null;

    // 1. Intentar buscar por ID exacto
    var mm = menuData.megamenus.find(function (m) { 
      return m.id === id && m.tabs && m.tabs.length > 0; 
    });

    if (mm) return mm;

    // 2. Fallback: Buscar por el label del item del navbar
    var navItem = (menuData.navbar.items || []).find(function (item) { return item.id === id; });
    if (!navItem) return null;

    var navLabel = _getText(navItem).toLowerCase().trim();

    return menuData.megamenus.find(function (m) {
      var mmLabel = _getText(m).toLowerCase().trim();
      return (mmLabel === navLabel || m.id === navLabel) && m.tabs && m.tabs.length > 0;
    });
  }

  /* ── Obtener Nombre del Menú (Con Fallback al Navbar) ── */
  function getMegamenuLabel(mm) {
    var label = _getText(mm);
    if (label) return label;

    var navItem = (menuData.navbar.items || []).find(function (item) { 
      return item.id === mm.id || (item.label || '').toLowerCase().trim() === (mm.id || '').toLowerCase().trim();
    });

    return navItem ? _getText(navItem) : '';
  }

  /* ── Abrir panel ─────────────────────────────── */
  function openPanel(id) {
    var mm = findMegamenu(id);
    if (!mm) return;

    var targetPanelId = 'mm51-panel-' + mm.id;
    if (!document.getElementById(targetPanelId)) return;

    clearTimeout(closeTimer);
    if (openRafId) cancelAnimationFrame(openRafId);

    _closeNow();

    activePanel = mm.id;
    setMmTop();

    if (mm.tabs && mm.tabs.length) {
      var preferredTabId = getPreferredTabId(mm);
      if (preferredTabId) {
        switchTab(mm.id, preferredTabId);
      }
    }

    var panel   = document.getElementById(targetPanelId);
    var overlay = getOverlay();
    var navItem = document.querySelector('[data-mm-id="' + id + '"]');

    if (panel) {
      openRafId = requestAnimationFrame(function () {
        openRafId = requestAnimationFrame(function () {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        });
      });
    }
    if (overlay) overlay.classList.add('is-visible');
    if (navItem) navItem.setAttribute('aria-expanded', 'true');
  }

  /* ── Cerrar inmediatamente ───────────────────── */
  function _closeNow() {
    if (openRafId) cancelAnimationFrame(openRafId);

    var allPanels = document.querySelectorAll('.mm51-panel.is-open');
    Array.from(allPanels).forEach(function(p) {
      p.classList.remove('is-open');
      p.setAttribute('aria-hidden', 'true');
    });

    var allNavItems = document.querySelectorAll('[data-mm-id]');
    Array.from(allNavItems).forEach(function(ni) {
      ni.setAttribute('aria-expanded', 'false');
    });

    var overlay = getOverlay();
    if (overlay) overlay.classList.remove('is-visible');

    activePanel = null;
  }

  /* ── Cerrar con delay (para hover) ──────────── */
  function scheduleClose() {
    closeTimer = setTimeout(_closeNow, 120);
  }

  /* ── Cancelar cierre pendiente ───────────────── */
  function cancelClose() {
    clearTimeout(closeTimer);
  }

  /* ── Cambio de tab ───────────────────────────── */
  function switchTab(panelId, tabId) {
    var panelEl = document.getElementById('mm51-panel-' + panelId);
    if (!panelEl) return;

    Array.from(panelEl.querySelectorAll('.mm51-tab')).forEach(function (btn) {
      var active = btn.dataset.tabId === tabId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    Array.from(panelEl.querySelectorAll('.mm51-tab-panel')).forEach(function (tp) {
      tp.classList.toggle('is-active', tp.dataset.tabPanel === tabId);
    });

    updateTabAction(panelEl, panelId, tabId);
  }

  /* ── CTA del tab activo en el header del panel ───── */
  function updateTabAction(panelEl, panelId, tabId) {
    var action = panelEl.querySelector('.mm51-tabs-nav__action');
    if (!action || !menuData) return;

    var mm = (menuData.megamenus || []).find(function (m) { return m.id === panelId; });
    var tab = mm && (mm.tabs || []).find(function (t) { return t.id === tabId; });
    var hasSizeGrid = tab && (tab.columns || []).some(function (col) {
      return col.type === 'size-grid';
    });

    if (!tab || !tab.footer || !tab.footer.url || hasSizeGrid) {
      action.classList.add('is-hidden');
      action.removeAttribute('href');
      action.textContent = '';
      return;
    }

    var tabLabel = _getText(tab);
    action.href = tab.footer.url;
    action.textContent = 'Ver todo ' + tabLabel;
    action.classList.remove('is-hidden');
  }

  /* ════════════════════════════════════════════════
     BUILDERS — columnas
  ════════════════════════════════════════════════ */

  function buildLinksColumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--links';
    _appendTitle(div, _getText(col.title || col));

    var ul = document.createElement('ul');
    ul.className = 'mm51-links';
    (col.links || []).forEach(function (link) {
      var li = document.createElement('li');
      li.appendChild(_linkEl(link.url, _getText(link), 'mm51-link'));
      ul.appendChild(li);
    });
    div.appendChild(ul);
    return div;
  }

  function buildLinksMulticolumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--links-multicolumn';
    _appendTitle(div, _getText(col.title || col));

    var inner = document.createElement('div');
    inner.className = 'mm51-multicolumn';

    (col.columns || []).forEach(function (subLinks) {
      var subDiv = document.createElement('div');
      subDiv.className = 'mm51-multicolumn__col';
      var ul = document.createElement('ul');
      ul.className = 'mm51-links';
      subLinks.forEach(function (link) {
        var li = document.createElement('li');
        li.appendChild(_linkEl(link.url, _getText(link), 'mm51-link'));
        ul.appendChild(li);
      });
      subDiv.appendChild(ul);
      inner.appendChild(subDiv);
    });
    div.appendChild(inner);
    return div;
  }

  function buildImagesColumn(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--images';
    _appendTitle(div, _getText(col.title || col));

    var inner = document.createElement('div');
    inner.className = 'mm51-images';

    (col.images || []).forEach(function (img) {
      var a = document.createElement('a');
      a.href = img.url;
      a.className = 'mm51-imglink';

      var imgEl = document.createElement('img');
      imgEl.src = img.src;
      imgEl.alt = img.alt || _getText(img) || '';
      imgEl.loading = 'lazy';
      imgEl.className = 'mm51-imglink__img';
      a.appendChild(imgEl);

      var captionText = img.alt || _getText(img);
      if (captionText) {
        var cap = document.createElement('span');
        cap.className = 'mm51-imglink__caption';
        cap.textContent = captionText;
        a.appendChild(cap);
      }
      inner.appendChild(a);
    });
    div.appendChild(inner);
    return div;
  }

  function buildSizeGrid(col) {
    var div = document.createElement('div');
    div.className = 'mm51-col mm51-col--size-grid';
    _appendTitle(div, _getText(col.title || col));

    var grid = document.createElement('div');
    grid.className = 'mm51-size-grid';
    (col.sizes || []).forEach(function (size) {
      grid.appendChild(_linkEl(size.url, _getText(size), 'mm51-size'));
    });
    div.appendChild(grid);
    return div;
  }

  function buildColumn(col) {
    var el;
    switch (col.type) {
      case 'links':             el = buildLinksColumn(col);     break;
      case 'links-multicolumn': el = buildLinksMulticolumn(col); break;
      case 'images':            el = buildImagesColumn(col);    break;
      case 'size-grid':         el = buildSizeGrid(col);        break;
      default:
        el = document.createElement('div');
        el.className = 'mm51-col';
    }

    var w = col.width || {};
    el.style.setProperty('--col-desktop', w.desktop || 3);
    el.style.setProperty('--col-tablet',  w.tablet  || 6);
    el.style.setProperty('--col-mobile',  w.mobile  || 12);

    return el;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — tab panel
  ════════════════════════════════════════════════ */
  function buildTabPanel(tab, megaId, isActive) {
    var panel = document.createElement('div');
    panel.className = 'mm51-tab-panel' + (isActive ? ' is-active' : '');
    panel.dataset.tabPanel = tab.id;
    panel.setAttribute('role', 'tabpanel');
    panel.id = 'mm51-tp-' + megaId + '-' + tab.id;
    panel.setAttribute('aria-labelledby', 'mm51-tb-' + megaId + '-' + tab.id);

    var grid = document.createElement('div');
    grid.className = 'mm51-grid';
    (tab.columns || []).forEach(function (col) {
      grid.appendChild(buildColumn(col));
    });
    panel.appendChild(grid);

    if (tab.footer) {
      var footer = document.createElement('div');
      footer.className = 'mm51-tab-footer';
      if (tab.footer.type === 'button') {
        var a = document.createElement('a');
        a.href    = tab.footer.url;
        a.className = 'btn btn--solid btn--black';
        a.textContent = _getText(tab.footer) || 'Ver productos';
        footer.appendChild(a);
      }
      panel.appendChild(footer);
    }

    return panel;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — mega panel (overlay)
  ════════════════════════════════════════════════ */
  function _mmEntry(hierarchy, mm) {
    var labelNorm = _normalizeKey(_getText(mm));
    var labelOrig = _getText(mm).toLowerCase().trim();
    var idNorm    = _normalizeKey(mm.id || '');
    var idOrig    = (mm.id || '').toLowerCase().trim();
    return hierarchy[labelNorm] || hierarchy[labelOrig] || hierarchy[idNorm] || hierarchy[idOrig] || null;
  }

  function _tabSubOrder(entry, tab) {
    var lnorm = _normalizeKey(_getText(tab));
    var lorig = _getText(tab).toLowerCase().trim();
    var inorm = _normalizeKey(tab.id || '');
    var iorig = (tab.id || '').toLowerCase().trim();
    var raw = (entry.children && (
      entry.children[lnorm] || entry.children[lorig] ||
      entry.children[inorm] || entry.children[iorig]
    )) || [];
    if (!raw.length) raw = entry.order || [];
    return raw;
  }

  function _syncLinks(links, subOrderRaw, mmChildKey) {
    var subOrder = subOrderRaw.map(_normalizeKey);
    var childLinks  = (window.MM51_MENU_CHILD_LINKS  && window.MM51_MENU_CHILD_LINKS[mmChildKey])  || {};
    var childTitles = (window.MM51_MENU_CHILD_TITLES && window.MM51_MENU_CHILD_TITLES[mmChildKey]) || {};

    var hasOverlap = links.some(function (l) {
      return subOrder.indexOf(_normalizeKey(_getText(l))) !== -1;
    });

    if (!hasOverlap) return links;

    // Filtrar items no presentes en el linklist
    links = links.filter(function (l) {
      return subOrder.indexOf(_normalizeKey(_getText(l))) !== -1;
    });

    // Agregar items del linklist que faltan en el panel
    var present = {};
    links.forEach(function (l) { present[_normalizeKey(_getText(l))] = true; });

    subOrderRaw.forEach(function (rawKey, i) {
      var normKey = _normalizeKey(rawKey);
      if (present[normKey]) return;
      var url   = childLinks[rawKey] || childLinks[normKey] || '#';
      var title = childTitles[rawKey] || childTitles[normKey] || rawKey;
      links.push({ label: title, url: url });
      present[normKey] = true;
    });

    links.sort(function (a, b) {
      var aIdx = subOrder.indexOf(_normalizeKey(_getText(a)));
      var bIdx = subOrder.indexOf(_normalizeKey(_getText(b)));
      if (aIdx === -1) aIdx = 9999;
      if (bIdx === -1) bIdx = 9999;
      return aIdx - bIdx;
    });

    return links;
  }

  function applyTabOrder(data) {
    var hierarchy = window.MM51_MENU_HIERARCHY;
    if (!hierarchy || !data || !data.megamenus) return;

    data.megamenus.forEach(function (mm) {
      var entry = _mmEntry(hierarchy, mm);
      if (!entry || !entry.order || !entry.order.length || !mm.tabs) return;

      var tabOrder = entry.order.map(_normalizeKey);

      mm.tabs.sort(function (a, b) {
        var aLabel = _normalizeKey(_getText(a)); var aId = _normalizeKey(a.id || '');
        var bLabel = _normalizeKey(_getText(b)); var bId = _normalizeKey(b.id || '');
        var aIdx = tabOrder.indexOf(aLabel); if (aIdx === -1) aIdx = tabOrder.indexOf(aId);
        var bIdx = tabOrder.indexOf(bLabel); if (bIdx === -1) bIdx = tabOrder.indexOf(bId);
        if (aIdx === -1) aIdx = 9999;
        if (bIdx === -1) bIdx = 9999;
        return aIdx - bIdx;
      });

      mm.tabs.forEach(function (tab, idx) { tab.default = (idx === 0); });
    });
  }

  function applySubcategoryOrder(data) {
    var hierarchy = window.MM51_MENU_HIERARCHY;
    if (!hierarchy || !data || !data.megamenus) return;

    data.megamenus.forEach(function (mm) {
      var entry = _mmEntry(hierarchy, mm);
      if (!entry) return;

      // Clave para MM51_MENU_CHILD_LINKS (coincide con | downcase de Liquid)
      var mmChildKey = _getText(mm).toLowerCase().trim() || (mm.id || '').toLowerCase().trim();

      (mm.tabs || []).forEach(function (tab) {
        var subOrderRaw = _tabSubOrder(entry, tab);
        if (!subOrderRaw.length) return;

        (tab.columns || []).forEach(function (col) {
          if (col.links && col.links.length) {
            col.links = _syncLinks(col.links.slice(), subOrderRaw, mmChildKey);
          } else if (col.type === 'links-multicolumn' && col.columns && col.columns.length) {
            var numCols = col.columns.length;
            var allLinks = [];
            col.columns.forEach(function (subCol) {
              subCol.forEach(function (link) { allLinks.push(link); });
            });
            allLinks = _syncLinks(allLinks, subOrderRaw, mmChildKey);
            var newCols = [];
            for (var i = 0; i < numCols; i++) newCols.push([]);
            allLinks.forEach(function (link, i) { newCols[i % numCols].push(link); });
            col.columns = newCols;
          }
        });
      });
    });
  }

  function _normalizeKey(str) {
    if (!str) return '';
    return str.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function applyMenuOrder(data) {
    var order = window.MM51_MENU_ORDER;
    var links = window.MM51_MENU_LINKS || {};
    var titles = window.MM51_MENU_TITLES || {};
    if (!order || !order.length || !data) return;

    // Índice de items existentes del metafield por label normalizado e id
    var itemsMap = {};
    ((data.navbar && data.navbar.items) || []).forEach(function (item) {
      var byLabel = _normalizeKey(_getText(item));
      var byId    = _normalizeKey(item.id || '');
      itemsMap[byLabel] = item;
      if (byId && byId !== byLabel) itemsMap[byId] = item;
    });

    // Índice de megamenus por label normalizado e id
    var megamenusMap = {};
    (data.megamenus || []).forEach(function (mm) {
      var byLabel = _normalizeKey(_getText(mm));
      var byId    = _normalizeKey(mm.id || '');
      megamenusMap[byLabel] = mm;
      if (byId && byId !== byLabel) megamenusMap[byId] = mm;
    });

    if (!data.navbar) data.navbar = {};

    // Reconstruir navbar.items en el orden exacto del linklist de Shopify
    data.navbar.items = order.map(function (linkKey) {
      var normKey = _normalizeKey(linkKey);

      // Buscar item existente en el metafield (por label o id normalizado)
      var existingItem = itemsMap[linkKey] || itemsMap[normKey];
      if (existingItem) return existingItem;

      // Si no existe en el metafield, crear item básico desde el linklist
      var hasMegamenu = (megamenusMap[linkKey] || megamenusMap[normKey]);
      hasMegamenu = hasMegamenu && (hasMegamenu.tabs || []).length > 0;
      return {
        id: linkKey,
        label: titles[linkKey] || (linkKey.charAt(0).toUpperCase() + linkKey.slice(1)),
        type: hasMegamenu ? 'megamenu' : 'link',
        url: links[linkKey] || '#'
      };
    });
  }

  function getPreferredTabId(mm) {
    var tabs = mm && mm.tabs ? mm.tabs.slice() : [];
    if (!tabs.length) return null;

    var defaultTabs = tabs.filter(function (tab) {
      return tab && tab.default === true;
    });

    if (defaultTabs.length) {
      return defaultTabs[0].id;
    }

    return tabs[0].id;
  }

  function buildMegaPanel(mm) {
    var wrapper = document.createElement('div');
    wrapper.className = 'mm51-panel';
    wrapper.id = 'mm51-panel-' + mm.id;
    wrapper.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('div');
    inner.className = 'mm51-panel__inner';

    var categoryTitleText = getMegamenuLabel(mm);

    var tabs = mm.tabs || [];
    if (tabs.length) {
      var defaultTabId = getPreferredTabId(mm);
      var nav = document.createElement('nav');
      nav.className = 'mm51-tabs-nav';
      nav.setAttribute('role', 'tablist');
      nav.setAttribute('aria-label', categoryTitleText);

      var tabsListWrap = document.createElement('div');
      tabsListWrap.className = 'mm51-tabs-list';

      tabs.forEach(function (tab) {
        var isActive = defaultTabId && tab.id === defaultTabId;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mm51-tab' + (isActive ? ' is-active' : '');
        btn.id = 'mm51-tb-' + mm.id + '-' + tab.id;
        btn.dataset.tabId = tab.id;
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('aria-controls', 'mm51-tp-' + mm.id + '-' + tab.id);
        btn.textContent = _getText(tab);

        btn.addEventListener('click', (function (tid) {
          return function () { switchTab(mm.id, tid); };
        })(tab.id));
        tabsListWrap.appendChild(btn);
      });

      nav.appendChild(tabsListWrap);

      var action = document.createElement('a');
      action.className = 'mm51-tabs-nav__action is-hidden';
      nav.appendChild(action);
      inner.appendChild(nav);

      var tabPanelsWrap = document.createElement('div');
      tabPanelsWrap.className = 'mm51-tab-panels';
      tabs.forEach(function (tab) {
        tabPanelsWrap.appendChild(buildTabPanel(tab, mm.id, defaultTabId && tab.id === defaultTabId));
      });
      inner.appendChild(tabPanelsWrap);
    }

    wrapper.appendChild(inner);

    wrapper.addEventListener('mouseenter', cancelClose);
    wrapper.addEventListener('mouseleave', scheduleClose);

    return wrapper;
  }

  /* ════════════════════════════════════════════════
     BUILDERS — nav item (barra superior)
  ════════════════════════════════════════════════ */
  function buildNavItem(item) {
    var el = document.createElement('div');
    el.className = 'mm51-nav-item';
    el.dataset.mmId = item.id;

    if (item.type === 'megamenu') {
      el.setAttribute('aria-haspopup', 'true');
      el.setAttribute('aria-expanded', 'false');
    }

    var a = document.createElement('a');
    a.href = item.url || '#';
    a.className = 'navlink navlink--toplevel';

    if (item.style) {
      Object.keys(item.style).forEach(function (k) {
        a.style.setProperty(k, item.style[k]);
      });
    }

    var itemText = _getText(item);

    /* HIGHLIGHT SOLO A NIVEL NAV */
    var highlightConfig = getHeaderHighlightConfig();
    if (highlightConfig && highlightConfig.item) {
      if (itemText.trim().toLowerCase() === highlightConfig.item) {
        a.classList.add('is-highlighted');
        if (highlightConfig.color) {
          a.style.color = highlightConfig.color;
        }
        a.style.fontWeight = '700';
      }
    }

    var span = document.createElement('span');
    span.className = 'navtext';
    span.textContent = itemText;
    a.appendChild(span);
    el.appendChild(a);

    if (item.type === 'megamenu') {
      el.addEventListener('mouseenter', (function (id) {
        return function () { cancelClose(); openPanel(id); };
      })(item.id));

      el.addEventListener('mouseleave', scheduleClose);

      a.addEventListener('keydown', (function (id) {
        return function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (activePanel === id) _closeNow();
            else openPanel(id);
          }
        };
      })(item.id));
    }

    return el;
  }

  /* ════════════════════════════════════════════════
     RENDER & EVENTOS
  ════════════════════════════════════════════════ */
  function render() {
    var navbar    = getNavbar();
    var panelsCtr = getPanels();
    if (!navbar || !panelsCtr || !menuData) return;

    navbar.innerHTML = '';
    (menuData.navbar.items || []).forEach(function (item) {
      navbar.appendChild(buildNavItem(item));
    });

    panelsCtr.innerHTML = '';
    (menuData.megamenus || []).forEach(function (mm) {
      if (mm.tabs && mm.tabs.length > 0) {
        panelsCtr.appendChild(buildMegaPanel(mm));
      }
    });
  }

  function attachGlobalEvents() {
    var overlay = getOverlay();
    if (overlay && overlay.dataset.mm51Bound !== 'true') {
      overlay.addEventListener('click', _closeNow);
      overlay.dataset.mm51Bound = 'true';
    }

    if (globalEventsAttached) return;
    globalEventsAttached = true;

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activePanel) _closeNow();
    });

    window.addEventListener('resize', setMmTop, { passive: true });
  }

  function _linkEl(href, text, cls) {
    var a = document.createElement('a');
    a.href = href;
    a.className = cls;
    a.textContent = text;
    return a;
  }

  function _appendTitle(parent, title) {
    if (!title) return;
    var p = document.createElement('p');
    p.className = 'mm51-col__title';
    p.textContent = title;
    parent.appendChild(p);
  }

  function _arrowSvg() {
    return '<svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 0.75L4.6875 4.78354L0.75 8.625" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function _appendMobileTabFooter(panel, tab) {
    if (!tab.footer) return;

    var footer = document.createElement('div');
    footer.className = 'mm51-mpanel__tab-footer';

    if (tab.footer.type === 'button') {
      var btn = document.createElement('a');
      btn.href = tab.footer.url;
      btn.className = 'mm51-mpanel__tab-footer-btn';
      btn.textContent = 'Ver más ' + _getText(tab);
      footer.appendChild(btn);
    }

    panel.appendChild(footer);
  }

  /* ════════════════════════════════════════════════
     MOBILE DRAWER
  ════════════════════════════════════════════════ */
  var mobileDrawer = {
    container: null,
    overlay: null,
    panelStack: [],
    isOpen: false,
    isInitialized: false,
    secondaryLinks: [],
    showSearch: true,

    init: function() {
      if (this.isInitialized) {
        this.attachMobileEvents();
        return;
      }

      var openBtn = document.querySelector('[data-mm51-open]');
      if (openBtn && openBtn.dataset.mm51ShowSearch !== undefined) {
        this.showSearch = openBtn.dataset.mm51ShowSearch !== 'false';
      }

      this.collectSecondaryLinks();
      this.buildDrawerDOM();
      this.attachMobileEvents();
      this.isInitialized = true;
    },

    collectSecondaryLinks: function() {
      var links = [];
      var containerExtras = document.querySelector('.container-extras');
      if (containerExtras) {
        var extraLinks = containerExtras.querySelectorAll('a.icon-nav');
        extraLinks.forEach(function(link) {
          var text = link.querySelector('span');
          if (text && link.href) {
            links.push({
              label: text.textContent.trim(),
              url: link.getAttribute('href')
            });
          }
        });
      }

      if (links.length === 0) {
        var accountLink = document.querySelector('a[href*="/account"]');
        if (accountLink) {
          links.push({ label: 'Mi cuenta', url: '/account' });
        }

        var trackLink = document.querySelector('[href*="seguimiento"], [href*="track"]');
        if (trackLink) {
          links.push({
            label: trackLink.textContent.trim(),
            url: trackLink.getAttribute('href')
          });
        }

        var helpLink = document.querySelector('[href*="/pages/ayuda"], [href*="/pages/help"], [href*="/pages/centro"]');
        if (helpLink) {
          links.push({
            label: helpLink.textContent.trim(),
            url: helpLink.getAttribute('href')
          });
        }
      }

      this.secondaryLinks = links;
    },

    buildDrawerDOM: function() {
      var existingDrawer = document.getElementById('mm51-mobile-drawer');
      if (existingDrawer) {
        this.container = existingDrawer;
        this.overlay = existingDrawer.querySelector('.mm51-mdrawer__overlay');
        this.panelsContainer = existingDrawer.querySelector('.mm51-mdrawer__panels');
        return;
      }

      var drawer = document.createElement('div');
      drawer.id = 'mm51-mobile-drawer';
      drawer.className = 'mm51-mdrawer';
      drawer.setAttribute('aria-hidden', 'true');

      var overlay = document.createElement('div');
      overlay.className = 'mm51-mdrawer__overlay';
      overlay.addEventListener('click', this.close.bind(this));

      var inner = document.createElement('div');
      inner.className = 'mm51-mdrawer__inner';

      var panelsContainer = document.createElement('div');
      panelsContainer.className = 'mm51-mdrawer__panels';
      panelsContainer.id = 'mm51-mdrawer-panels';

      inner.appendChild(panelsContainer);
      drawer.appendChild(overlay);
      drawer.appendChild(inner);
      document.body.appendChild(drawer);

      this.container = drawer;
      this.overlay = overlay;
      this.panelsContainer = panelsContainer;
    },

    attachMobileEvents: function() {
      var self = this;
      var openBtns = document.querySelectorAll('[data-mm51-open]');

      openBtns.forEach(function(openBtn) {
        if (openBtn.dataset.mm51Bound === 'true') return;

        openBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.open();
        }, true);

        openBtn.dataset.mm51Bound = 'true';
        openBtn.setAttribute('aria-haspopup', 'dialog');
        openBtn.setAttribute('aria-controls', 'mm51-mobile-drawer');
        openBtn.setAttribute('aria-expanded', 'false');
      });

      if (!this.escapeBound) {
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && self.isOpen) {
            self.close();
          }
        });
        this.escapeBound = true;
      }
    },

    open: function() {
      if (!menuData) return;

      this.isOpen = true;
      this.panelStack = [];
      this.renderPanel1();

      this.container.classList.add('is-open');
      this.container.setAttribute('aria-hidden', 'false');
      this.updateTriggerState(true);
      document.documentElement.classList.add('mm51-no-scroll');
      document.body.classList.add('mm51-no-scroll');
    },

    close: function() {
      this.isOpen = false;
      this.container.classList.remove('is-open');
      this.container.setAttribute('aria-hidden', 'true');
      this.updateTriggerState(false);
      document.documentElement.classList.remove('mm51-no-scroll');
      document.body.classList.remove('mm51-no-scroll');

      var self = this;
      setTimeout(function() {
        self.panelsContainer.innerHTML = '';
        self.panelStack = [];
      }, 300);
    },

    updateTriggerState: function(isExpanded) {
      document.querySelectorAll('[data-mm51-open]').forEach(function(openBtn) {
        openBtn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      });
    },

    renderPanel1: function() {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--1 is-active';
      panel.dataset.level = '1';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'mm51-mpanel__close';
      closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      closeBtn.addEventListener('click', this.close.bind(this));

      header.appendChild(closeBtn);
      panel.appendChild(header);

      if (this.showSearch) {
        var searchBar = document.createElement('div');
        searchBar.className = 'mm51-mpanel__search';
        searchBar.innerHTML = '<div class="mm51-mpanel__search-inner">' +
          '<input type="search" placeholder="¿Qué estás buscando?" class="mm51-mpanel__search-input" />' +
          '<button type="button" class="mm51-mpanel__search-btn">' +
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.4985 12.4985L16.5 16.5M14.4993 7.49964C14.4993 11.3669 11.3669 14.4993 7.49964 14.4993C3.63234 14.4993 0.5 11.3669 0.5 7.49964C0.5 3.63234 3.63234 0.5 7.49964 0.5C11.3669 0.5 14.4993 3.63234 14.4993 7.49964Z" stroke="#222222" stroke-linecap="square" stroke-linejoin="round"/></svg>' +
          '</button>' +
        '</div>';

        var searchInput = searchBar.querySelector('.mm51-mpanel__search-input');
        var searchBtn = searchBar.querySelector('.mm51-mpanel__search-btn');

        var handleSearch = function() {
          var query = searchInput.value.trim();
          if (query.length > 0) {
            window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
          }
        };

        searchBtn.addEventListener('click', handleSearch);
        searchInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSearch();
          }
        });

        panel.appendChild(searchBar);
      }

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      var navbar = menuData.navbar;
      if (navbar && navbar.items) {
        navbar.items.forEach(function(item) {
          var li = document.createElement('li');
          li.className = 'mm51-mlist__item';
          var itemLabel = _getText(item);

          if (item.type !== 'megamenu') {
            var aSimple = document.createElement('a');
            aSimple.href = item.url || '#';
            aSimple.className = 'mm51-mlist__link';
            if (item.style && item.style.color) aSimple.style.color = item.style.color;

            var spanSimple = document.createElement('span');
            spanSimple.textContent = itemLabel;
            
            aSimple.appendChild(spanSimple);
            li.appendChild(aSimple);
          } 
          else {
            var wrapper = document.createElement('div');
            wrapper.className = 'mm51-mlist__link';
            wrapper.style.display = 'flex';
            wrapper.style.justifyContent = 'space-between';
            wrapper.style.alignItems = 'center';
            wrapper.style.padding = '0';

            if (item.style && item.style.color) {
              wrapper.style.color = item.style.color;
            }

            var textLink = document.createElement('a');
            textLink.href = item.url || '#';
            textLink.style.color = 'inherit';
            textLink.style.flexGrow = '1';
            textLink.style.textDecoration = 'none';
            
            var spanText = document.createElement('span');
            spanText.textContent = itemLabel;
            textLink.appendChild(spanText);

            var arrowLink = document.createElement('a');
            arrowLink.href = '#';
            arrowLink.className = 'mm51-mlist__arrow';
            arrowLink.style.color = 'inherit';
            arrowLink.style.display = 'flex';
            arrowLink.style.alignItems = 'center';

            var svgContainer = document.createElement('div');
            svgContainer.className = 'container-svg';
            svgContainer.innerHTML = _arrowSvg();
            
            arrowLink.appendChild(svgContainer);

            arrowLink.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              mobileDrawer.goToPanel2(item.id, itemLabel);
            });

            wrapper.appendChild(textLink);
            wrapper.appendChild(arrowLink);
            li.appendChild(wrapper);
          }

          list.appendChild(li);
        });
      }

      body.appendChild(list);

      if (this.secondaryLinks.length > 0) {
        var footer = document.createElement('div');
        footer.className = 'mm51-mpanel__footer';

        this.secondaryLinks.forEach(function(link) {
          var a = document.createElement('a');
          a.href = link.url;
          a.className = 'mm51-mpanel__footer-link';
          a.textContent = _getText(link);
          footer.appendChild(a);
        });

        body.appendChild(footer);
      }

      panel.appendChild(body);
      this.panelsContainer.innerHTML = '';
      this.panelsContainer.appendChild(panel);
      this.panelStack.push({ level: 1, element: panel });
    },

    goToPanel2: function(megamenuId, megamenuLabel) {
      var megamenu = findMegamenu(megamenuId);

      if (!megamenu || !megamenu.tabs) return;

      // Si solo hay un tab con contenido, ir directo a Panel 3 (evita nivel intermedio innecesario)
      var navigableTabs = megamenu.tabs.filter(function(tab) {
        return (tab.columns || []).some(function(col) {
          return col.links || col.columns || col.sizes || col.type === 'images' || (col.images && col.images.length > 0);
        });
      });
      if (navigableTabs.length === 1) {
        mobileDrawer.goToPanel3(megamenu.id, megamenuLabel, navigableTabs[0], _getText(navigableTabs[0]));
        return;
      }

      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--2';
      panel.dataset.level = '2';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var title = document.createElement('span');
      title.className = 'mm51-mpanel__title';
      title.textContent = megamenuLabel;

      header.appendChild(backBtn);
      header.appendChild(title);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      megamenu.tabs.forEach(function(tab) {
        /* 🌟 CORRECCIÓN MOBILE: Se incluye col.type === 'images' como contenido válido navegable */
        var hasNavigableColumns = (tab.columns || []).some(function(col) {
          return col.links || col.columns || col.sizes || col.type === 'images' || (col.images && col.images.length > 0);
        });

        var li = document.createElement('li');
        li.className = 'mm51-mlist__item';

        var a = document.createElement('a');
        a.href = '#';
        a.className = 'mm51-mlist__link';

        var tabLabel = _getText(tab);
        var span = document.createElement('span');
        span.textContent = tabLabel;
        a.appendChild(span);

        if (hasNavigableColumns) {
          var arrow = document.createElement('span');
          arrow.className = 'mm51-mlist__arrow';
          arrow.innerHTML = _arrowSvg();
          a.appendChild(arrow);

          a.addEventListener('click', function(e) {
            e.preventDefault();
            mobileDrawer.goToPanel3(megamenu.id, megamenuLabel, tab, tabLabel);
          });
        }

        li.appendChild(a);
        list.appendChild(li);
      });

      body.appendChild(list);
      panel.appendChild(body);

      this.addPanel(panel);
    },

    goToPanel3: function(megamenuId, megamenuLabel, tab, tabLabel) {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--3';
      panel.dataset.level = '3';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var breadcrumb = document.createElement('span');
      breadcrumb.className = 'mm51-mpanel__breadcrumb';
      breadcrumb.textContent = megamenuLabel + ' • ' + tabLabel;

      header.appendChild(backBtn);
      header.appendChild(breadcrumb);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      var list = document.createElement('ul');
      list.className = 'mm51-mlist';

      var navigableColumns = (tab.columns || []).filter(function(col) {
        return col.type !== 'images' && (col.links || col.columns || col.sizes);
      });

      // Aplanar columnas: mostrar links directamente en Panel 3 (sin nivel navegable intermedio)
      navigableColumns.forEach(function(col) {
        if (col.type === 'links') {
          (col.links || []).forEach(function(link) {
            var li = document.createElement('li');
            li.className = 'mm51-mlist__item';
            var a = document.createElement('a');
            a.href = link.url;
            a.className = 'mm51-mlist__link';
            a.textContent = _getText(link);
            li.appendChild(a);
            list.appendChild(li);
          });
        } else if (col.type === 'links-multicolumn') {
          (col.columns || []).forEach(function(subCol) {
            subCol.forEach(function(link) {
              var li = document.createElement('li');
              li.className = 'mm51-mlist__item';
              var a = document.createElement('a');
              a.href = link.url;
              a.className = 'mm51-mlist__link';
              a.textContent = _getText(link);
              li.appendChild(a);
              list.appendChild(li);
            });
          });
        } else if (col.type === 'size-grid') {
          var gridLi = document.createElement('li');
          gridLi.className = 'mm51-mlist__item';
          var grid = document.createElement('div');
          grid.className = 'mm51-msize-grid';
          (col.sizes || []).forEach(function(size) {
            var a = document.createElement('a');
            a.href = size.url;
            a.className = 'mm51-msize';
            a.textContent = _getText(size);
            grid.appendChild(a);
          });
          gridLi.appendChild(grid);
          list.appendChild(gridLi);
        }
      });

      /* 🌟 CORRECCIÓN MOBILE: Renderizado de imágenes promocionales dentro de Mobile */
      var imageColumns = (tab.columns || []).filter(function(col) {
        return col.type === 'images' || (col.images && col.images.length > 0);
      });

      imageColumns.forEach(function(col) {
        if (col.images && col.images.length > 0) {
          col.images.forEach(function(img) {
            var imgLi = document.createElement('li');
            imgLi.className = 'mm51-mlist__promo';

            var imgLink = document.createElement('a');
            imgLink.href = img.url || '#';
            imgLink.className = 'mm51-mlist__promo-link';

            var imgEl = document.createElement('img');
            imgEl.src = img.src;
            imgEl.alt = img.alt || _getText(col.title || col) || _getText(img) || '';
            imgEl.loading = 'lazy';

            imgLink.appendChild(imgEl);

            var captionText = _getText(col.title || col) || img.alt || _getText(img);
            if (captionText) {
              var caption = document.createElement('span');
              caption.className = 'mm51-mlist__promo-caption';
              caption.textContent = captionText;
              imgLink.appendChild(caption);
            }

            imgLi.appendChild(imgLink);
            list.appendChild(imgLi);
          });
        }
      });

      body.appendChild(list);
      panel.appendChild(body);
      _appendMobileTabFooter(panel, tab);

      this.addPanel(panel);
    },

    goToPanel4: function(megamenuId, megamenuLabel, tab, tabLabel, column) {
      var panel = document.createElement('div');
      panel.className = 'mm51-mpanel mm51-mpanel--4';
      panel.dataset.level = '4';

      var header = document.createElement('div');
      header.className = 'mm51-mpanel__header';

      var backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'mm51-mpanel__back';
      backBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      backBtn.addEventListener('click', this.goBack.bind(this));

      var breadcrumb = document.createElement('span');
      breadcrumb.className = 'mm51-mpanel__breadcrumb';
      breadcrumb.textContent = megamenuLabel + ' • ' + tabLabel + ' • ' + (_getText(column.title || column));

      header.appendChild(backBtn);
      header.appendChild(breadcrumb);
      panel.appendChild(header);

      var body = document.createElement('div');
      body.className = 'mm51-mpanel__body';

      if (column.type === 'links') {
        var list = document.createElement('ul');
        list.className = 'mm51-mlist mm51-mlist--links';

        (column.links || []).forEach(function(link) {
          var li = document.createElement('li');
          li.className = 'mm51-mlist__item';

          var a = document.createElement('a');
          a.href = link.url;
          a.className = 'mm51-mlist__link';
          a.textContent = _getText(link);

          li.appendChild(a);
          list.appendChild(li);
        });

        body.appendChild(list);
      }
      else if (column.type === 'links-multicolumn') {
        var list = document.createElement('ul');
        list.className = 'mm51-mlist mm51-mlist--links';

        (column.columns || []).forEach(function(subCol) {
          subCol.forEach(function(link) {
            var li = document.createElement('li');
            li.className = 'mm51-mlist__item';

            var a = document.createElement('a');
            a.href = link.url;
            a.className = 'mm51-mlist__link';
            a.textContent = _getText(link);

            li.appendChild(a);
            list.appendChild(li);
          });
        });

        body.appendChild(list);
      }
      else if (column.type === 'size-grid') {
        var grid = document.createElement('div');
        grid.className = 'mm51-msize-grid';

        (column.sizes || []).forEach(function(size) {
          var a = document.createElement('a');
          a.href = size.url;
          a.className = 'mm51-msize';
          a.textContent = _getText(size);
          grid.appendChild(a);
        });

        body.appendChild(grid);
      }

      panel.appendChild(body);

      this.addPanel(panel);
    },

    addPanel: function(panel) {
      this.panelsContainer.appendChild(panel);

      var currentPanel = this.panelStack[this.panelStack.length - 1];
      if (currentPanel) {
        currentPanel.element.classList.remove('is-active');
        currentPanel.element.classList.add('is-leaving');
      }

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          panel.classList.add('is-active');
        });
      });

      this.panelStack.push({ level: panel.dataset.level, element: panel });
    },

    goBack: function() {
      if (this.panelStack.length <= 1) return;

      var currentPanel = this.panelStack.pop();
      var previousPanel = this.panelStack[this.panelStack.length - 1];

      currentPanel.element.classList.remove('is-active');
      currentPanel.element.classList.add('is-exiting');

      if (previousPanel) {
        previousPanel.element.classList.remove('is-leaving');
        previousPanel.element.classList.add('is-active');
      }

      setTimeout(function() {
        if (currentPanel.element.parentNode) {
          currentPanel.element.parentNode.removeChild(currentPanel.element);
        }
      }, 300);
    }
  };

  /* ════════════════════════════════════════════════
     INICIALIZACIÓN
  ════════════════════════════════════════════════ */
  function init() {
    menuData = window.MM51_DATA;
    if (!menuData) {
      console.warn('[MM51] window.MM51_DATA no está definido.');
      return;
    }

    applyMenuOrder(menuData);
    applyTabOrder(menuData);
    applySubcategoryOrder(menuData);
    render();
    attachGlobalEvents();
    setMmTop();
    mobileDrawer.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (
      e.target && (
        e.target.querySelector('#mm51-navbar') ||
        e.target.querySelector('#mm51-panels') ||
        e.target.querySelector('[data-mm51-open]')
      )
    ) {
      if (menuData) {
        render();
        setMmTop();
        mobileDrawer.init();
      } else {
        init();
      }
    }
  });

})();